import {
  Create,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  TextInput,
  SimpleForm,
  FileInput,
  FileField,
  useRedirect,
  useNotify,
  ImageInput,
  ImageField,
} from "react-admin";
export default function MusicCreate(props) {
  const redirect = useRedirect();
  const notify = useNotify();
  return (
    <Create {...props}>
      <SimpleForm>
        <ImageInput
          source="song_poster"
          label="Related pictures"
          accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
        <ReferenceArrayInput
          label="Artist"
          reference="artists"
          source="Artist_ids">
          <AutocompleteArrayInput
            onCreate={() => {
              redirect("/artists/create");
              notify("navigate to artists");
              // const newTagName = prompt("Enter a new tag");
              // const newTag = { id: newTagName.toLowerCase(), name: newTagName };

              // return newTag;
            }}
          />
        </ReferenceArrayInput>
        <ReferenceArrayInput
          label="Album"
          reference="albums"
          source="Album_ids">
          <AutocompleteArrayInput
            onCreate={() => {
              // const newTagName = prompt("Enter a new tag");
              // const newTag = { id: newTagName.toLowerCase(), name: newTagName };
              // return newTag;
            }}
          />
        </ReferenceArrayInput>
        <ReferenceArrayInput
          label="Geners"
          reference="geners"
          source="Geners_ids">
          <AutocompleteArrayInput
            onCreate={() => {
              // const newTagName = prompt("Enter a new tag");
              // const newTag = { id: newTagName.toLowerCase(), name: newTagName };
              // return newTag;
            }}
          />
        </ReferenceArrayInput>
        <TextInput label="Artist_ids" source="Artist_ids"></TextInput>
        <TextInput source="name" />
        <TextInput multiline source="description" />
        <FileInput multiple={true} source="song" label="Related files">
          <FileField source="song" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
}
